// @mui
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Card, Stack, Typography, Grid, Avatar } from '@mui/material';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import SvgColor from 'src/components/svg-color';
// locales
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

type Stat = {
  title: string;
  value: string;
  icon: string;
};

// ----------------------------------------------------------------------

export default function AuthStatisticsTopStats() {
  const { t } = useLocales();
  const theme = useTheme();

  const lgUp = useResponsive('up', 1200);
  const xlDown = useResponsive('down', 1400);
  const smUp = useResponsive('up', 600);
  const mdDown = useResponsive('down', 950);

  const stats: Stat[] = [
    {
      title: t('ai_models_count'),
      value: t('ai'),
      icon: '/assets/icons/global/ri--apps-2-ai-line.svg',
    },
    {
      title: t('free_start'),
      value: t('with_3000_token'),
      icon: '/assets/icons/global/iconamoon--gift-light.svg',
    },
    {
      title: t('flexible_purchasing'),
      value: t('no_expiration'),
      icon: '/assets/icons/global/streamline-plump--payment-recieve-7.svg',
    },
  ];

  return (
    <Grid container spacing={2.5} sx={{ mb: 4 }}>
      {stats.map((item: Stat, index: number) => (
        <Grid item xs={12} sm={4} key={`top-stats-${index}`}>
          <Card
            sx={{
              p: 2,
              height: '100%',
              borderRadius: 3,
              position: 'relative',
              overflow: 'hidden',
              backdropFilter: 'blur(20px)',
              background: alpha(theme.palette.common.white, 0.05),
              border: `1px solid ${alpha(theme.palette.common.white, 0.08)}`,
              boxShadow: `0 0 40px ${alpha(theme.palette.primary.main, 0.08)}`,
            }}
          >
            <Stack
              direction={(lgUp && xlDown) || (smUp && mdDown) ? 'column' : 'row'}
              spacing={2}
              alignItems="center"
            >
              <Avatar
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.14),
                  width: 48,
                  height: 48,
                }}
              >
                <SvgColor
                  src={item.icon}
                  color="text.primary"
                  sx={{ width: 24, height: 24, mt: index === 2 ? -0.25 : undefined }}
                />
              </Avatar>

              <Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 700,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    // color: alpha(theme.palette.common.white, 0.6),
                    color: 'text.secondary',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    // maxWidth: 115,
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            </Stack>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
